import React, { Fragment } from 'react'
import { Marker } from "react-google-maps";
import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel"
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';
import { useSelector } from 'react-redux';
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';

const PointQuyHoach = (props) => {
    const { points, labelActive, selected, hienthidiem } = useSelector(state => state.quyHoach);
    const onPolygonPress = (e) => () => {
        props.onClickEvnt(e)
    }
    return (
        <Fragment>
            {

                hienthidiem === 'diemchon' ?

                    <MarkerClusterer
                        averageCenter
                        enableRetinaIcons
                        gridSize={60}
                        maxZoom={20}

                    >
                        {
                            points.map((e, i) => {

                                return (
                                    <Marker
                                        key={e.id}
                                        position={e['polygon']}
                                        icon={e.icon}
                                        visible={labelActive.includes(e.label) && e.id !== selected.id}
                                        onClick={onPolygonPress(e)}
                                    />

                                )
                            })
                        }
                    </MarkerClusterer>
                    :

                    points.map((e, i) => {
                        return (
                            <InForBox key={e.id} item={e}/>
                        )
                    })

            }

        </Fragment>
    )
}

export default React.memo(PointQuyHoach)
// <MarkerWithLabel
//     key={e.id}
//     position={e['polygon']}
//     labelAnchor={[0, 0]}
//     visible={labelActive.includes(e.label) && e.id !== selected.id}
//     labelStyle={{ backgroundColor: e.strokeColor, fontSize: "14px", padding: "5px 10px", borderRadius: 5 }}  >
//     <div>{e.diadanh}</div>
// </MarkerWithLabel>

const InForBox = React.memo (({ item })=>{
    return (
        <InfoBox
            key={item.id}
            // onLoad={() => { }}
            className="infobox"
            options={{ closeBoxURL: '', enableEventPropagation: true }}
            position={item['polygon']}
        // visible={labelActive.includes(e.label) && e.id !== selected.id}
        >
            <div className='label-point'  onClick={() => {   }}>
                <div >
                    {item.diadanh}
                </div>
            </div>
        </InfoBox>
    )
}) 
  
